import React from 'react'

function Trend() {
  return (
    <div></div>
  )
}

export default Trend